import { Injectable } from 'angular-ts-decorators';

import { find, map, values } from 'lodash';
export interface ICountryInfoObject {
  code: string;
  name: string;
}

/**
 * Service that allows the retrieving country list in current language
 * Country list source: https://github.com/pieterbergwerff/node-countries-list
 */
@Injectable('country')
export class Country {
  private languageKeys: object;
  constructor(private language: any) {
    'ngInject';

    this.languageKeys = {
      // supported i18n list
      'nl-nl': require('node-countries-list/src/data/nl/country.json'),
      'en-gb': require('node-countries-list/src/data/en/country.json'),
      'fr-fr': require('node-countries-list/src/data/fr/country.json'),
      'de-de': require('node-countries-list/src/data/de/country.json'),
      'it-it': require('node-countries-list/src/data/it/country.json'),
      'es-es': require('node-countries-list/src/data/es/country.json'),
    };
  }

  private getList(): object {
    if (this.languageKeys[this.language.current]) {
      return this.languageKeys[this.language.current];
    } else {
      return this.languageKeys['en-gb'];
    }
  }

  /**
   * Returns an array of countries in a current language
   * @returns {Array<String>}
   * countries
   */
  getCountryList(): string[] {
    return values(this.getList());
  }

  /**
   * Returns an array filled with country info objects
   * ```
   * {
   *  code:'NL'
   *  name: 'Nederland'
   * }
   * ```
   * @returns {Array<Object>} countryObjects
   */
  getCountryInfoList(): ICountryInfoObject[] {
    let list = this.getList();

    return map(list, (name, code) => {
      return {
        code,
        name,
      };
    });
  }

  /**
   * ngdoc
   * Returns a element as country info object.
   * Or returns undefined if not found
   * ```
   * {
   *  code:'NL'
   *  name: 'Nederland'
   * }
   * ```
   * @param {String} countryCode code of the country you want to find
   * @return {Object} Returns country info object or undefined
   */
  getCountryByCode(countryCode): ICountryInfoObject {
    return find(this.getCountryInfoList(), { code: countryCode as string });
  }
}
